import { API } from '../api';
import { IPagination } from '../IPagination';
import { IApiKey, IApiKeyCreated, ICreateApiKey } from './interface';

export const fetchApiKeys = async (signal?: AbortSignal | null): Promise<IPagination<IApiKey>> => {
    const params = new URLSearchParams({
        sortField: 'date_created',
        sortOrder: 'descend',
        offset: '0',
        limit: '1000',
    }).toString();

    const response = await API.fetch(`/api-keys?${params}`, {
        ...(signal && { signal }),
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });

    const respBody: any = await response.json();

    if (response.ok) {
        return respBody;
    }

    throw new Error(respBody?.error?.message || `Cannot load API keys!`);
};

export const createApiKey = async (apiKey: ICreateApiKey): Promise<IApiKeyCreated> => {
    const response = await API.fetch('/api-keys', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(apiKey),
    });

    const respBody: any = await response.json();

    if (response.ok) {
        return respBody;
    }

    throw new Error(respBody?.error?.message || `Cannot create API key!`);
};

export const revokeApiKey = async (id: string): Promise<void> => {
    const response = await API.fetch(`/api-keys/${id}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
        },
    });

    if (response.ok) {
        return;
    }

    const respBody: any = await response.json();
    throw new Error(respBody?.error?.message || `Cannot revoke API key!`);
};
